import React from 'react';
import CircleButton from 'components/v2/buttons/CircleButton';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import SessionStore from 'stores/SessionStore';

const BLACK_LISTED_NON_ADMIN_ACTION_FIELD = ['fsc_pending_job_closure'];

export default function NonActionableNextStep({ item }) {
  const { t } = useTranslation();

  const isAdmin = SessionStore.isAdmin();
  const renderIcon = () => {
    return <Clock className="w-5 h-5" />;
  };

  if (!isAdmin && BLACK_LISTED_NON_ADMIN_ACTION_FIELD.includes(item.field))
    return null;
  return (
    <div>
      <div className="flex justify-between text-sm text-gray-700  py-1 items-center">
        <span>{t(sluggify(item.field))}</span>
        <CircleButton size="small" disabled={item.complete} onClick={null}>
          {renderIcon()}
        </CircleButton>
      </div>
    </div>
  );
}
